
interface Field<T> {
  label: string
  key: keyof T
  placeholder?: string
  readOnly?: boolean
}

const basic: Field<Pick<order.Cart, 'name' | 'phone' | 'email'>>[] = [{
  key: 'name',
  label: 'Imię i nazwisko',
  placeholder: 'np. Adam Kowalski'
}, {
  key: 'email',
  label: 'E-mail',
  placeholder: 'np. adam@wp.pl'
}, {
  key: 'phone',
  label: 'Numer telefonu',
  placeholder: 'np. 123 456 789'
}]


const invoice: Field<order.Invoice>[] = [{
  key: 'company_name',
  label: 'Nazwa firmy',
  placeholder: 'np. Horio Sp. z o.o.'
}, {
  key: 'nip',
  label: 'NIP',
  placeholder: 'np. 7312004398'
}, {
  key: 'company_address',
  label: 'Adres firmy',
  placeholder: 'np. 93-004 Kraków, ul. Warszawska 12'
}]


const company: Field<order.Courier>[] = [{
  key: 'name',
  label: 'Imię i nazwisko',
  placeholder: 'np. Adam Kowalski'
}, {
  label: 'Numer dla kuriera',
  key: 'phone',
  placeholder: 'np. 123 456 789'
}, {
  label: 'Miejscowość',
  key: 'city',
  placeholder: 'np. Kraków'
}, {
  label: 'Kod Pocztowy',
  key: 'zip',
  placeholder: 'np. 93-004'
}, {
  label: 'Ulica',
  key: 'street',
  placeholder: 'np. Warszawska'
}, {
  label: 'Numer budynku',
  key: 'estate_number',
  placeholder: 'np. 2'
}, {
  label: 'Numer mieszkania',
  key: 'local_number',
  placeholder: 'np. 12'
}, {
  label: 'Uwagi',
  key: 'comments',
  placeholder: 'np. wjazd od południowej bramy'
}]

export { basic, invoice, company }